import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/user';
import _ from 'lodash'
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import Title from '../components/common/Title';
import ActionButton from '../components/common/ActionButton';
import { signUp } from '../services/auth';
import { Mixpanel } from '../mixpanel';

const style = {
  container: {
	display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: window.innerHeight,
  	},
	errorText: {
		color: 'red'
	}
}

class SignUp extends Component {
	constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
	  role: 'Patient',
	  error: '',
      isTermAgreed: false,
    };
	
	this.createAccount = this.createAccount.bind(this)
  }

	createAccount() {
		if ( this.checkPassword() ){
			signUp(this.state.email, this.state.password, this.state.firstName, this.state.lastName,
				(ret)=>{
					if(_.isEmpty(ret.email)){
						this.setState({error: ret.description})
					} else {
						// successfully signed up, login automatically

						let defaultProfilePicture = "https://s3-us-west-2.amazonaws.com/system-data/web-app/images/avatar_default_user_profile.png"
						let profile = {
							email: ret.email,
							nickname: ret.user_metadata.given_name,
							picture: defaultProfilePicture,
						};
						let user = {
							email: ret.email,
							loginType: 'auth0',
							firstName: ret.user_metadata.given_name,
							lastName: ret.user_metadata.family_name,
							isProvider: this.state.role === "Patient" ? false : true,
							profilePhotoUrl: defaultProfilePicture,
						}

						Mixpanel.track('Sign up',{
							'Email':ret.email,
							'isProvider': this.state.role === "Patient" ? false : true,
							'Platform':'Web'
						})
						// call server to login and get user ID
						this.props.userLogin(user, profile);
						// go to the next page
						if (this.state.role === "Provider") {
							this.props.history.push("/home")
						} else {
							this.props.history.push("/view-channels")
						}
					}
				},
				(error)=>{
					this.setState({error})
				}
			)
		}

	}

	checkHasNumbers() {
		let password = this.state.password;
		if (password.match(/[0-9]+/)) {
			return true
		}else {
			return false 
		}
	}

	checkHasCharacterSmall(){
		let password = this.state.password;
		if (password.match(/[a-z]+/)) {
			return true
		}else {
			return false 
		}
	}

	checkHasCharacterCapital() {
		let password = this.state.password;
		if (password.match(/[A-Z]+/)) {
			return true
		}else {
			return false 
		}
	}

	checkHasCharacter() {
		let password = this.state.password;
		if (password.match(/[$@#&!]+/)) {
			return true
		}else {
			return false 
		}
	}

	checkPassword() {
		if ( this.state.password.length < 8){
			this.setState({error:'Your password must have at least 9 characters!'})
			return false
		}else{
			if ( this.checkHasNumbers() ){
				if( this.checkHasCharacterSmall() ){
					if( this.checkHasCharacterCapital()){
						if( this.checkHasCharacter()){
							return true
						}else{
							this.setState({error:'Your password must have at least one character($@#&!)!'})
						return false
						}
						
					}else{
						this.setState({error:'Your password must have at least one capital letter!'})
						return false
					}
				}else{
					this.setState({error:'Your password must have at least one small letter!'})
					return false
				}
				
			}else {
				this.setState({error:'Your password must have at least one number!'})
				return false
			}
		}

	}

	render() {
		return (
			<div style={style.container}>
				<Title text1='Create' text2="Your Account"/>
				<br />
				<TextField
					type="email"
					hintText="Enter your Email"
		      floatingLabelText="Email"
					value={this.state.email}
		      onChange = {(event) => this.setState({
						error: '',
						email: event.target.value
					})}
		      />
				<br />
				<TextField
					type = "password"
					hintText="Enter your Password"
					floatingLabelText="Password"
					value={this.state.password}
					onChange = {(event) => this.setState({
						error: '',
						password:event.target.value
					})}
		      />
        <br />
				<TextField
					hintText="Enter your first name"
					floatingLabelText="First Name"
					value={this.state.firstName}
					onChange = {(event) => this.setState({
						firstName:event.target.value
					})}
		      />
        <br />
				<TextField
					hintText="Enter your last name"
					floatingLabelText="Last Name"
					value={this.state.lastName}
					onChange = {(event) => this.setState({
						lastName:event.target.value
					})}
		      />
				<br />

				<RadioButtonGroup
					style={{ display: 'flex',width:250}}
					name="role"
					defaultSelected={this.state.role}
					onChange={(event) => { this.setState({ role: event.target.value }) }}
				>
					<RadioButton
						value="Patient"
						label="Patient"
					/>
					<RadioButton
						value="Provider"
						label="Provider"
					/>
				</RadioButtonGroup>
				<br />
				<div>
					<Checkbox
						style={{ marginLeft: 20 }}
						label={<div>I agree to the <a href="https://www.advicecoach.com/privacy-terms">Privacy Policy & Terms of Use</a></div>}
						checked={this.state.isTermAgreed}
						onCheck={() => { this.setState({ isTermAgreed: !this.state.isTermAgreed }) }}
					/>
				</div>
				<br />
				{!_.isEmpty(this.state.error) && <p style={style.errorText}>{this.state.error}</p>}
				<ActionButton label="Create" onClick={()=>this.createAccount()} disabled={!this.state.isTermAgreed || _.isEmpty(this.state.email) || _.isEmpty(this.state.password)} />
			</div>
		);
	}
}

function mapStateToProps({user}) {
	return {
		userId: user.userId,
	}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);



// WEBPACK FOOTER //
// ./src/layout/SignUp.js